import { render } from "./AppFolderCard.vue?vue&type=template&id=1efb669e&scoped=true&ts=true"
import script from "./AppFolderCard.vue?vue&type=script&lang=ts"
export * from "./AppFolderCard.vue?vue&type=script&lang=ts"

import "./AppFolderCard.vue?vue&type=style&index=0&id=1efb669e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efb669e"]])

export default __exports__